import capitalize from 'lodash/capitalize';
import {
  VocabEvents,
  QueryBuilderOrClause,
  Event,
  VocabularyDataTypes,
} from 'modules/predictiveGoals/types';
import {
  PropertyBase,
  getComparatorsBasedOnDataType,
} from 'modules/predictiveGoals/components/queryBuilder/components/PropertyBaseHelperFunctions';
import {
  ComparatorOptionsWithNoSymbols,
  ComparatorOptionsWithNoValueRequirement,
  DefaultPropertyComparatorEq,
  DefaultPropertyComparatorContains,
} from '../constants';

export const getFormattedEventDisplayName = (eventName: VocabEvents): string => {
  if (eventName === VocabEvents.USER) {
    return `User profile field`;
  } else {
    return `${capitalize(eventName)} event`;
  }
};

export const formatNumberForDisplay = (count: number, fractionDigits: number): string => {
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: fractionDigits,
  })
    .format(count)
    .toLowerCase();
};

export const propertyHasValues = (values: unknown[]) => values?.length > 0;

export const getNextPropertyComparison = (value: string | undefined, newComparator: string) => {
  if (ComparatorOptionsWithNoValueRequirement.includes(newComparator)) {
    return {
      value: undefined,
      comparator: newComparator,
    };
  } else {
    return {
      value,
      comparator: newComparator,
    };
  }
};

export const derivePropertyDescriptors = (
  orQuery: QueryBuilderOrClause,
  matchingPropertyByName: PropertyBase,
) => {
  const { dataType, property_comparison: propertyComparison } = orQuery || {};
  const { comparator } = propertyComparison || {};
  const isLowCardinalityProperty = propertyHasValues(matchingPropertyByName.values);
  return {
    isLowCardinalityProperty,
    filteredComparators: getComparatorsBasedOnDataType(
      dataType as string,
      isLowCardinalityProperty,
      matchingPropertyByName,
    ),
    noSymbolIncluded: ComparatorOptionsWithNoSymbols.includes(comparator || ''),
  };
};

export const getDefaultNoValuesComparatorByDataType = (dataType: string) => {
  if (dataType === VocabularyDataTypes.string) {
    return DefaultPropertyComparatorContains;
  }
  return DefaultPropertyComparatorEq;
};

export const getPropertyDefaultComparator = (filteredProperty: Event) => {
  if (!('values' in filteredProperty)) {
    return DefaultPropertyComparatorEq;
  }
  const isLowCardinalityProperty = filteredProperty?.values?.length > 0;
  return isLowCardinalityProperty
    ? DefaultPropertyComparatorEq
    : getDefaultNoValuesComparatorByDataType(filteredProperty?.dataType);
};
